(() => {
  'use strict';
  const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
  const behavior = () => reduced.matches ? 'auto' : 'smooth';
  const mainMenuButton = document.querySelector('[data-main-menu]');
  if (mainMenuButton) {
    const updateMainMenu = () => { mainMenuButton.hidden = window.scrollY < 300; };
    window.addEventListener('scroll', updateMainMenu, { passive: true });
    updateMainMenu();
  }
  function initBooks(root) {
    if (root.dataset.ziyaraReady) return;
    root.dataset.ziyaraReady = 'true';
    const buttons = [...root.querySelectorAll('[data-book-item]')];
    const cover = root.querySelector('.ed-cover');
    const index = root.querySelector('.ed-index');
    const viewer = root.querySelector('.ed-viewer');
    if (!buttons.length || !cover || !index || !viewer) return;
    let active = Math.max(0, buttons.findIndex(button => button.getAttribute('aria-pressed') === 'true')), gesture = null;
    const listeners = [];
    const listen = (el, type, fn, options) => { el.addEventListener(type, fn, options); listeners.push(() => el.removeEventListener(type, fn, options)); };
    function select(next, scroll = false) {
      active = (next % buttons.length + buttons.length) % buttons.length;
      const item = buttons[active], number = String(active + 1).padStart(2, '0');
      cover.src = item.dataset.cover;
      cover.removeAttribute('srcset');
      cover.alt = item.dataset.title + ' — full cover';
      root.querySelector('.ed-title').textContent = item.dataset.title;
      root.querySelector('.ed-description').textContent = item.dataset.description;
      root.querySelector('.ed-pages').textContent = item.dataset.pages + ' pages';
      root.querySelector('.ed-book-label').textContent = 'GUIDE ' + number + ' · PLUS EDITION';
      root.querySelector('.ed-edition-number').textContent = number;
      root.querySelector('.ed-position').textContent = number;
      buttons.forEach((button, i) => button.setAttribute('aria-pressed', String(i === active)));
      root.querySelectorAll('[data-guide-action]').forEach(action => { action.hidden = Number(action.dataset.guideAction) !== active; });
      if (scroll && window.matchMedia('(max-width:600px)').matches) {
        index.open = false;
        viewer.scrollIntoView({ behavior: behavior(), block: 'start' });
      }
    }
    buttons.forEach((button, i) => listen(button, 'click', () => select(i, true)));
    root.querySelectorAll('[data-book-direction]').forEach(button => listen(button, 'click', () => select(active + Number(button.dataset.bookDirection))));
    listen(viewer, 'pointerdown', event => { if (!event.target.closest('a,button,input,summary')) gesture = { x: event.clientX, y: event.clientY, id: event.pointerId }; });
    listen(viewer, 'pointerup', event => {
      if (!gesture || event.pointerId !== gesture.id) return;
      const dx = event.clientX - gesture.x, dy = event.clientY - gesture.y;
      gesture = null;
      if (Math.abs(dx) > 45 && Math.abs(dx) > Math.abs(dy) * 1.3) select(active + (dx < 0 ? 1 : -1));
    });
    listen(viewer, 'pointercancel', () => { gesture = null; });
    listen(cover, 'dragstart', event => event.preventDefault());
    listen(root, 'keydown', event => {
      if (!event.target.closest('.ed-navigation,[data-book-item]')) return;
      if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') { event.preventDefault(); select(active + (event.key === 'ArrowRight' ? 1 : -1)); if (index.open) buttons[active].focus({ preventScroll: true }); }
    });
    root.querySelectorAll('[data-explore-books]').forEach(link => listen(link, 'click', event => { event.preventDefault(); index.open = true; index.scrollIntoView({ behavior: behavior(), block: 'nearest' }); }));
    index.open = !window.matchMedia('(max-width:600px)').matches;
    root._ziyaraSelect = button => { const i = buttons.indexOf(button); if (i >= 0) select(i); };
    root._ziyaraCleanup = () => { listeners.forEach(remove => remove()); delete root.dataset.ziyaraReady; delete root._ziyaraSelect; };
  }
  function initTools(root) {
    if (root.dataset.ziyaraReady) return;
    root.dataset.ziyaraReady = 'true';
    const rail = root.querySelector('.zf-tool-rail');
    if (!rail) return;
    const controls = [...root.querySelectorAll('[data-tool-direction]')], listeners = [];
    const listen = (el, type, fn, options) => { el.addEventListener(type, fn, options); listeners.push(() => el.removeEventListener(type, fn, options)); };
    function update() {
      const last = Math.max(0, rail.scrollWidth - rail.clientWidth);
      controls.forEach(button => { button.disabled = Number(button.dataset.toolDirection) < 0 ? rail.scrollLeft < 2 : rail.scrollLeft >= last - 2; });
    }
    controls.forEach(button => listen(button, 'click', () => {
      const gap = parseFloat(getComputedStyle(rail).gap) || 18;
      rail.scrollBy({ left: Number(button.dataset.toolDirection) * ((rail.firstElementChild?.getBoundingClientRect().width || rail.clientWidth) + gap), behavior: behavior() });
    }));
    const observer = new ResizeObserver(update); observer.observe(rail);
    listen(rail, 'scroll', update, { passive: true });
    const checklists = [...root.querySelectorAll('.zf-sheet-packing')];
    checklists.forEach(sheet => {
      const inputs = [...sheet.querySelectorAll('input[type=checkbox]')], status = sheet.querySelector('.zf-packing-status');
      if (!status) return;
      const count = () => { status.textContent = inputs.filter(input => input.checked).length + ' of ' + inputs.length + ' essentials checked'; };
      inputs.forEach(input => listen(input, 'change', count));
    });
    root._ziyaraCleanup = () => { observer.disconnect(); listeners.forEach(remove => remove()); delete root.dataset.ziyaraReady; };
    update();
  }
  function boot(scope = document) {
    scope.querySelectorAll('[data-ziyara-books]').forEach(initBooks);
    scope.querySelectorAll('[data-ziyara-tools]').forEach(initTools);
  }
  document.addEventListener('shopify:section:load', event => boot(event.target));
  document.addEventListener('shopify:section:unload', event => event.target.querySelectorAll('[data-ziyara-books],[data-ziyara-tools]').forEach(root => root._ziyaraCleanup?.()));
  document.addEventListener('shopify:block:select', event => {
    const button = event.target.closest('[data-book-item]');
    if (button) button.closest('[data-ziyara-books]')?._ziyaraSelect?.(button);
  });
  boot();
})();
